import {useHistory, useParams} from "react-router-dom";
import {DashboardLayout} from "components/Layout";
import {SubmitButton} from "components/Button";
import {CircleLoader} from "components/Loader";
import {FormCard} from "components/Form";
import {useDetailActionCategory} from "hooks/SuperAdmin/ActionCategory";

export function ActionCategoryDetailPage() {
	const history = useHistory();
	const {id} = useParams();
	const {data: detailActionCategory, isLoading: loadingFetcing} = useDetailActionCategory(id);

	if (loadingFetcing) {
		return (
			<DashboardLayout>
				<FormCard backTitle="Daftar list kategori tindakan" title="Detail Kategori Tindakan">
					<CircleLoader />
				</FormCard>
			</DashboardLayout>
		);
	}

	return (
		<DashboardLayout>
			<FormCard
				backTitle="Daftar List Kategori Tindakan"
				title={`Detail Data Kategori Tindakan ${detailActionCategory?.data?.title}`}
				onBackButtonClick={() => history.push("/kategori-tindakan")}>
				<div class="row gx-2 mb-5">
					<div class="col-sm-6 col-6">
						<div class="setting-item">
							<label class="setting-label ">Nama Kategori Tindakan</label>
							<p className="text-bold text-grey">{detailActionCategory?.data?.title}</p>
						</div>
					</div>
				</div>

				<div class="text-center my-3">
					<SubmitButton
						className="btn btn-orange d-inline-block mw-250"
						text="Ubah Data Ini"
						onClick={() => history.push(`/kategori-tindakan/edit/${detailActionCategory?.data?.id}`)}
					/>
				</div>
			</FormCard>
		</DashboardLayout>
	);
}
